import React, { useState, useEffect } from 'react';
import { Autocomplete, Paper } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { TableContainer } from '@mui/material';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CLOUD_PROVIDER_SERVICES, ERRORS } from '../../../utils/constants';
import TextField from '@mui/material/TextField';
import { config } from './config';
import { handleError } from '../../../utils/config';
import { useHistory } from 'react-router-dom';
import { ReactComponent as CheckIcon } from '../../../assets/images/confirm-icon.svg';
import { ReactComponent as CancelIcon } from '../../../assets/images/cancel-icon.svg';
import { ReactComponent as AlertIcon } from '../../../assets/images/caution-icon.svg';
import './SystemHealth.css';
import TitleHeader from '../../../components/MasterComponent/TitleHeader/TitleHeader';
import Loading from '../../../components/Loading/Loading';

const ICONS: {
  [key: string]: React.ReactNode;
} = {
  error: <CancelIcon width={20} height={20} />,
  warn: <AlertIcon width={20} height={20} />,
  success: <CheckIcon width={20} height={20} />,
};
const ITEM_HEIGHT = 58;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

let accountCloudRelation: {
  [key: string]: string;
} = {};

const SystemHealth = () => {
  const history = useHistory();
  const [subCompanies, setSubCompanies] = useState<string[]>([]);
  const [activeAccountIds, setActiveAccountIds] = useState<string[]>([]);
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedAccount, setSelectedAccount] = useState<string>('');
  const [filteredSubCompany, setFilteredSubCompany] = useState<any[]>([]);
  const [jobFailureDetails, setJobFailurDetails] = useState<any[]>([]);
  const [systemHealthData, setSystemHealthData] = useState<any[]>([]);
  const [clicked, setClicked] = useState<any>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [jobFailurLoader, setJobFailurLoader] = useState<boolean>(false);
  const [networkError, setNetworkError] = useState('');

  // const SelectAccountRef = useRef<any>(null);

  const handleCompanyChange = (e: any, value: any) => {
    setSelectedCompany(value);
    fetchAccounts(value);
    setSelectedAccount('');
    setSystemHealthData([]);
    setClicked(false);
    setJobFailurDetails([]);
  };

  const handleSelectedAccountChange = (e: any) => {
    setSelectedAccount(e.target.value);
    setClicked(false);
    setJobFailurDetails([]);
  };

  const fetchSubscribedCompanies = async () => {
    try {
      const result = await config.getSubscribedCompanies();
      if (result.length) {
        const activeCompanies: string[] = [];
        result.forEach((company: any) => {
          if (company.IsActive) activeCompanies.push(company.name);
        });
        setSubCompanies(activeCompanies);
      }
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
    }
  };
  const fetchSystemHealthData = async () => {
    try {
      setLoader(true);
      const result = await config.getSystemHealthData(
        selectedAccount,
        selectedCompany
      );
      setSystemHealthData(result || []);
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      setLoader(false);
    }
  };

  const fetchAccounts = async (value: any) => {
    try {
      const result = await config.getActiveAccounts(value);
      accountCloudRelation = result.reduce((acc: any, current: any) => {
        if (current.AccountId)
          acc[current.AccountId] = CLOUD_PROVIDER_SERVICES.AWS;
        else acc[current.SubscriptionId] = CLOUD_PROVIDER_SERVICES.AZURE;
        return acc;
      }, {});

      setActiveAccountIds(result);
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    }
  };

  const fetchJobDetails = async (
    services: string,
    account: string,
    jobdate: string
  ) => {
    try {
      setClicked(true);
      setJobFailurLoader(true);

      const result = await config.getJobFailurDetails(
        services,
        account,
        jobdate,
        accountCloudRelation[selectedAccount]
      );
      setJobFailurDetails(result || []);
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      setJobFailurLoader(false);
    }
  };

  useEffect(() => {
    // Filter company based on inputValue
    const filtered = subCompanies?.filter((tag: string) =>
      tag.trim().toLowerCase()
    );
    setFilteredSubCompany(filtered);
  }, [subCompanies]);

  useEffect(() => {
    fetchSubscribedCompanies();
  }, []);
  useEffect(() => {
    fetchSystemHealthData();
  }, [selectedCompany, selectedAccount]);
  const flattenedSystemHealth =
    (systemHealthData || []).flatMap((account: any) =>
      Object.entries(account.health || {}).map(([serviceName, dates]: any) => ({
        account,
        serviceName,
        dates,
      }))
    ) || [];
  return (
    <>
      <div className="sContainer mb-15">
        <TitleHeader
          extraContent={
            <>
              <div className="flex-end flex w-50">
                <FormControl className="w-30">
                  <Autocomplete
                    id="demo-simple-select-outlined"
                    value={selectedCompany}
                    // className="w-40"
                    onChange={handleCompanyChange}
                    ListboxProps={{
                      style: {
                        whiteSpace: 'nowrap',
                        background: 'white',
                      },
                    }}
                    options={filteredSubCompany}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Company"
                        variant="outlined"
                        className="autocompleteInput"
                      />
                    )}
                    PaperComponent={(props) => (
                      <Paper {...props} className="autocompletePaper" />
                    )}
                    // popupIcon={<span className="autocompleteArrow">▼</span>}
                    className="selectDropdown"
                  />
                </FormControl>
                {selectedCompany && (
                  <FormControl className="w-30 ml-10">
                    <Autocomplete
                      id="select-account-autocomplete"
                      options={activeAccountIds}
                      getOptionLabel={(option: any) =>
                        option?.Name ||
                        option?.AccountId ||
                        option?.SubscriptionId ||
                        ''
                      }
                      value={
                        activeAccountIds.find(
                          (a: any) =>
                            (a.AccountId || a.SubscriptionId) ===
                            selectedAccount
                        ) || null
                      }
                      onChange={(e: any, value: any) => {
                        setSelectedAccount(
                          value ? value.AccountId || value.SubscriptionId : ''
                        );
                        setClicked(false);
                        setJobFailurDetails([]);
                      }}
                      ListboxProps={{
                        style: {
                          whiteSpace: 'nowrap',
                          background: 'white',
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Account"
                          variant="outlined"
                          className="autocompleteInput"
                        />
                      )}
                      PaperComponent={(props) => (
                        <Paper {...props} className="autocompletePaper" />
                      )}
                      className="selectDropdown"
                    />
                  </FormControl>
                )}
              </div>
            </>
          }
        >
          System Health
        </TitleHeader>
      </div>
      {loader ? (
        <Loading
          style={{
            height: '70vh',
          }}
        />
      ) : systemHealthData?.length ? (
        <TableContainer
          sx={{ maxHeight: '60vh', overflowY: 'auto' }}
          className="accContainer mt-10 mb-10"
        >
          <Table
            className="table adminTable adminPanelTable"
            stickyHeader
            size="small"
            aria-label="a dense table"
          >
            <TableHead className="admintableHead">
              <TableRow>
                <TableCell
                  width="1%"
                  align="center"
                  className="adminTableheading"
                >
                  Sr. No.
                </TableCell>
                <TableCell
                  width="5%"
                  align="center"
                  className="adminTableheading"
                >
                  ACCOUNT ID
                </TableCell>
                <TableCell
                  width="5%"
                  align="center"
                  className="adminTableheading"
                >
                  ACCOUNT NAME
                </TableCell>
                <TableCell
                  width="3%"
                  align="center"
                  className="adminTableheading"
                >
                  CLOUD
                </TableCell>
                <TableCell
                  width="10%"
                  align="center"
                  className="adminTableheading"
                >
                  SERVICE
                </TableCell>
                {systemHealthData?.[0]?.health &&
                  Object.keys(
                    systemHealthData[0].health[
                      Object.keys(systemHealthData[0].health)[0]
                    ]
                  ).map((date: string, index: number) => (
                    <TableCell
                      key={index + date}
                      align="center"
                      className="adminTableheading"
                    >
                      {new Date(date)
                        .toDateString()
                        .split(' ')[1]
                        .toUpperCase()}
                      -{new Date(date).toDateString().split(' ')[2]}
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {flattenedSystemHealth.map((row: any, rowIndex: number) => (
                <TableRow key={`row-${rowIndex}`}>
                  <TableCell>{rowIndex + 1}</TableCell>
                  <TableCell>{row.account.accountId}</TableCell>
                  <TableCell>{row.account.name}</TableCell>
                  <TableCell>{row.account.cloud}</TableCell>
                  <TableCell>{row.serviceName.toUpperCase()}</TableCell>
                  {Object.entries(row.dates).map((entry: any, i: number) => (
                    <TableCell align="center" key={i}>
                      <span
                        className={entry[1] !== 'success' ? 'cursor' : ''}
                        onClick={() => {
                          if (entry[1] !== 'success')
                            fetchJobDetails(
                              row.serviceName,
                              row.account.accountId,
                              entry[0]
                            );
                        }}
                      >
                        {ICONS[entry[1]]}
                      </span>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : !selectedCompany ? (
        <div className="noDataText">Please select Organization</div>
      ) : systemHealthData && systemHealthData.length === 0 ? (
        <div className="noDataText">
          No accounts available for the selected organization
        </div>
      ) : (
        <div className="noDataText">No record found</div>
      )}

      {jobFailurLoader ? (
        <div className="incompleteJobText mt-30">Loading...</div>
      ) : jobFailureDetails.length ? (
        <TableContainer
          sx={{ maxHeight: '315px', overflowY: 'scroll' }}
          className="accContainer mt-40 mb-10"
        >
          <Table
            className="table adminTable adminPanelTable"
            size="small"
            aria-label="a dense table"
            stickyHeader
          >
            <TableHead className="admintableHead">
              <TableRow>
                <TableCell
                  width="1%"
                  align="center"
                  className="adminTableheading"
                >
                  Sr. No.
                </TableCell>

                {Object.keys(jobFailureDetails[0]).map(
                  (key: string, index: number) => (
                    <TableCell
                      key={index + key}
                      align="center"
                      className="adminTableheading"
                    >
                      {key.split('_').join(' ').toUpperCase()}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {jobFailureDetails?.map((row: any, index: number) => (
                <TableRow key={index} className={row.status ? '' : 'redRow'}>
                  <TableCell>{++index}</TableCell>
                  {Object.values(row).map((detail: any, i: number) => (
                    <TableCell align="center" key={i}>
                      {typeof detail === 'boolean'
                        ? detail
                          ? 'True'
                          : 'False'
                        : detail || '---'}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : !jobFailureDetails.length && clicked ? (
        <div className="incompleteJobText mt-30">
          The job remains incomplete due to an unresolved issue.{' '}
        </div>
      ) : null}
    </>
  );
};

export default SystemHealth;
